import { FC } from "react";

import { Button } from "@src/lib/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@src/lib/ui/Dialog";
import Text from "@src/lib/ui/Text";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

const RemoveSelfAsOwnerDialog: FC<Props> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove yourself as an owner?</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col">
          <Text variant="compact-description" multiline>
            You&apos;re removing yourself as an owner of this chat. Once you
            save, you&apos;ll no longer be able to edit its title, members, or
            permissions, and unless you&apos;re also one of its members
            you&apos;ll lose access to the chat entirely. Only another owner can
            make you an owner again.
          </Text>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Remove
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveSelfAsOwnerDialog;
